const EVENTS = {
    AUTHENTICATED: 'authenticated',
    FACEBOOK_LOGIN: 'facebook.login.success',
    SHOW_LOGIN_MODAL: 'showLoginDialog',
    SHOW_REGISTER_MODAL: 'showRegisterDialog',
};

export default EVENTS;
